{
  "venue-portal": {
    "reservations": {
      "organizer": "Organiser",
      "expenses": {
        "fetchError": "Something went wrong when fetching the bill",
        "uploadCheck": "Upload Bill",
        "itemizedCheck": "Itemised Bill",
        "noCheckDetected": "No Bill Detected",
        "checkDetailsPending": "Your bill details will be here after the reservation.",
        "editItemizedCheckTitle": "Edit Itemised Bill",
        "uploadItemizedCheckTitle": "Upload Itemised Bill",
        "uploadCheckPostTitle": "Upload the itemised bill which shows all the items that were purchased, tax, and any mandatory gratuity",
        "editCheckButton": "Edit Bill",
        "deleteItemizedCheckLabel": "Delete Itemised Bill",
        "checkDetailsLabel": "Bill Details",
        "itemizedCheckFileLabel": "Itemised Bill File",
        "deleteCheckConfirmButton": "Yes, Delete Bill",
        "keepCheckButton": "Keep Bill",
        "uploadedCheckAlt": "uploaded bill"
      }
    },
    "fees": {
      "salesTaxPlaceholder": "e.g. VAT"
    },
    "analytics": {
      "paymentMethodsHelp": "Corporate events that were paid outside of Ande (e.g. wire, cheque, or direct card charge). Using an Ande paylink would have lowered the processing cost."
    },
    "widget": {
      "inquiryFormHelp": "Shown to guests while they fill out enquiry form. Edit to set expectations, share any special instructions, or add a personal welcome.",
      "enableInquiryHoursOverride": "Enable enquiry hours override",
      "selectDayInquiryHours": "Select a day above to add enquiry hours for that day."
    },
    "agent": {
      "websiteInquiriesDescription": "Your AI agent handles website enquiries using your venue's knowledge and preferences."
    },
    "agentDashboard": {
      "inquiryInsights": "Enquiry Insights",
      "timing": {
        "heatmapTitle": "When guests enquire — day of week & time of day",
        "heatmapTooltip": "Volume of inbound enquiries by day of week and hour of day, in venue-local time. Use it to spot when staffing or auto-response coverage matters most — especially the share that lands outside business hours, when no human could reply.",
        "noInquiries": "No enquiries in {{scope}}{{suffix}} yet.",
        "outsideHours": "{{pct}}% of enquiries arrive outside business hours",
        "weekendShare": "Weekend enquiries account for {{pct}}% of total volume.",
        "leadTimeNote": "Days between enquiry and requested event date · median with 25th–75th range",
        "leadTimeTooltip": "How far in advance guests enquire, broken down by party size. The bar shows the middle 50% of enquiries (25th–75th percentile); the line is the median. Bigger parties typically plan further out — knowing this helps you set hold times and follow-up cadence.",
        "noLeadTimeInquiries": "No enquiries with an event date and party size in this period yet."
      },
      "guestInsights": {
        "eventTypesTooltip": "Split of enquiries into corporate, social, and other event categories, with each event type ranked by lead volume within its category. Useful for tuning menus, packages, and marketing toward your strongest demand.",
        "noPartySizeInquiries": "No enquiries with a party size yet",
        "partySizeNote": "Guest count requested on {{inquiryCount}} enquiries · most common {{verb}} {{topBuckets}} guests ({{topPct}}%)",
        "noPartySizeInquiriesPeriod": "No enquiries with a party size in this period yet."
      },
      "analytics": {
        "leadsSubmittedMeta": "Enquiries submitted through the agent",
        "leadsSubmittedTooltip": "Total inbound enquiries submitted through the agent.",
        "avgExchangesTooltip": "Average back-and-forth messages per engaged conversation. Longer exchanges usually mean the guest is genuinely planning a booking; very short ones may signal the enquiry was answered and closed quickly.",
        "noInquiriesPeriod": "No enquiries in this period yet.",
        "noVenueInquiriesPeriod": "No venue enquiries in this period yet."
      }
    }
  },
  "venue-agent": {
    "form": {
      "closeLabel": "Close event enquiry"
    },
    "thankYou": {
      "body": "Your event enquiry has been received."
    },
    "configError": {
      "label": "Event enquiry unavailable"
    },
    "submittedForm": {
      "collapseLabel": "Collapse enquiry details",
      "expandLabel": "Expand enquiry details"
    },
    "smsConsent": {
      "label": "Text me for follow-ups on this enquiry."
    },
    "status": {
      "updatingInquiry": "Updating your enquiry",
      "updatingInquiryDetails": "Updating the enquiry details"
    }
  }
}
